import { isUserGlobalAdmin } from './user-global-admin.util';

/** The premium feature that gates every part of the intake layout v2 redesign. */
export const INTAKE_LAYOUT_V2 = 'INTAKE_LAYOUT_V2';

/**
 * Whether this firm may see any of the intake layout v2 work.
 *
 * One definition, used by every surface the redesign touches — the intake builder, the Case Fields
 * registry, the sidebar layout authoring changes, the workflow step placement editor and the case
 * panel's per-value editing. Reading `premium_features` inline in six places is how one of them ends
 * up ungated, which is exactly what happened before this existed.
 *
 * **Eligibility, not capability.** Whether a firm's form has actually been migrated is a property of
 * the form (`layout_version`), and no flag substitutes for it. This only decides whether they see
 * anything new at all.
 *
 * Staff bypass it so support and demos never need a toggle flipped on a real firm first.
 */
export function isIntakeLayoutV2Enabled(
  // Structurally typed, not `Organization`, to avoid a circular dependency between @ee/common/utils
  // and @ee/common/models — the same reason `isUserGlobalAdmin` and `subscription-access` do it.
  org: { premium_features?: { [key: string]: boolean } } | null | undefined,
  user?: { authorities?: unknown[] } | null
): boolean {
  if (user && isUserGlobalAdmin(user)) {
    return true;
  }
  return org?.premium_features?.[INTAKE_LAYOUT_V2] === true;
}
